module.exports = __webpack_public_path__ + "static/video2-87529975370166eebfd16f912f67f624.png";